export default __webpack_public_path__ + "6e7f32765f9afe7d80c69daec91b7dfe.png";